import { Link, useLocation } from 'react-router-dom'
import {
  MdOutlineHome,
  MdHome,
  MdOutlineWorkOutline,
  MdWorkOutline,
  MdOutlineGridView,
  MdGridView,
  MdOutlinePerson,
  MdPerson,
  MdOutlineDescription,
  MdDescription,
  MdOutlineComputer,
  MdOutlinePalette,
} from 'react-icons/md'
import { IoSunnyOutline, IoMoonOutline } from 'react-icons/io5'
import './CanvasHeader.css'

const navItems = [
  { to: '/', label: 'Home', Icon: MdOutlineHome, ActiveIcon: MdHome, end: true },
  {
    to: '/work',
    label: 'Experience',
    Icon: MdOutlineWorkOutline,
    ActiveIcon: MdWorkOutline,
  },
  {
    to: '/projects',
    label: 'Projects',
    Icon: MdOutlineGridView,
    ActiveIcon: MdGridView,
  },
  {
    to: '/about',
    label: 'About',
    Icon: MdOutlinePerson,
    ActiveIcon: MdPerson,
  },
  {
    to: '/resume',
    label: 'Résumé',
    Icon: MdOutlineDescription,
    ActiveIcon: MdDescription,
  },
]

const themeOptions = [
  { id: 'light', label: 'Light', Icon: IoSunnyOutline },
  { id: 'dark', label: 'Dark', Icon: IoMoonOutline },
  { id: 'system', label: 'System', Icon: MdOutlineComputer },
]

function CanvasHeader({
  theme,
  setTheme,
  resolvedTheme,
  nextDesignLanguage,
  setDesignLanguage,
}) {
  const location = useLocation()
  const currentPath = location.pathname
  const nextDesignName = nextDesignLanguage === 'material3' ? 'Canvas' : 'Aqua'

  const isCurrent = (item) =>
    item.end ? currentPath === item.to : currentPath.startsWith(item.to)

  const renderNavItems = (itemClass, indicatorClass, labelClass) => (
    <>
      {navItems.map((item) => {
        const active = isCurrent(item)
        return (
          <Link
            key={item.to}
            to={item.to}
            className={`${itemClass} ${active ? 'active' : ''}`}
            aria-current={active ? 'page' : undefined}
          >
            <span className={indicatorClass}>
              {active ? <item.ActiveIcon /> : <item.Icon />}
            </span>
            <span className={labelClass}>{item.label}</span>
          </Link>
        )
      })}
    </>
  )

  return (
    <>
      <header className="canvas-topbar" role="banner">
        <div className="canvas-topbar-shell">
          <Link to="/" className="canvas-brand" aria-label="Alan Pham, home">
            <img
              src="logo.png"
              alt=""
              width={32}
              height={32}
              className="canvas-logo canvas-logo-light"
            />
            <img
              src="logo-dark.png"
              alt=""
              width={32}
              height={32}
              className="canvas-logo canvas-logo-dark"
            />
            <span className="canvas-brand-name">Alan Pham</span>
          </Link>

          <div className="canvas-topbar-controls">
            <div
              className="canvas-segmented"
              data-active-theme={theme}
              role="group"
              aria-label={`Color theme. Current: ${theme}${theme === 'system' ? `, following ${resolvedTheme}` : ''}.`}
            >
              {themeOptions.map(({ id, label, Icon }) => (
                <button
                  key={id}
                  type="button"
                  className={`canvas-segment ${theme === id ? 'active' : ''}`}
                  onClick={() => setTheme(id)}
                  aria-pressed={theme === id}
                  title={`Use ${label.toLowerCase()} appearance`}
                  aria-label={`Use ${label.toLowerCase()} appearance`}
                >
                  <Icon aria-hidden="true" />
                </button>
              ))}
            </div>
            <button
              type="button"
              className="canvas-design-toggle"
              onClick={() => setDesignLanguage(nextDesignLanguage)}
              title={`Switch to ${nextDesignName}`}
              aria-label={`Current theme: Canvas. Switch to ${nextDesignName}.`}
            >
              <MdOutlinePalette aria-hidden="true" />
              <span className="canvas-design-toggle-label">Canvas</span>
            </button>
          </div>
        </div>
      </header>

      <nav className="canvas-rail" aria-label="Primary">
        <div className="canvas-rail-items">
          {renderNavItems(
            'canvas-rail-item',
            'canvas-rail-indicator',
            'canvas-rail-label'
          )}
        </div>
      </nav>

      <nav className="canvas-bottom-nav" aria-label="Primary">
        {renderNavItems(
          'canvas-bottom-nav-item',
          'canvas-bottom-nav-indicator',
          'canvas-bottom-nav-label'
        )}
      </nav>
    </>
  )
}

export default CanvasHeader
